import { makeStyles } from '@material-ui/core';
import { GridCheckCircleIcon } from '@material-ui/data-grid';
import CancelIcon from '@material-ui/icons/Cancel';
import { MIN_PASSWORD_LENGTH } from '../../../constants/constants';

const useStyles = makeStyles((theme: any) => ({
    container: {

    }
}));

interface Props {
    password: string;
    confirmPassword: string;
}

export const PasswordRequirements: React.FC<Props> = ({ password, confirmPassword }) => {
    const validLowerUpper = new RegExp(
        '(.*[a-z].*)(.*[A-Z].*)'
    );

    function containsNumbers(str: string) {
        return /\d/.test(str);
      }

    return (
        <div>
            <div>
                {password.length >= MIN_PASSWORD_LENGTH ? <GridCheckCircleIcon  color='primary' /> : <CancelIcon />} Password must contain 8 characters
            </div>
            <div>
                {validLowerUpper.test(password) ? <GridCheckCircleIcon color='primary'  /> : <CancelIcon/>} Password must contain a lower and upper case letter
            </div>
            <div>
                {containsNumbers(password) ? <GridCheckCircleIcon  color='primary'  /> : <CancelIcon/>} Password must contain a number
            </div>
            <div>
                {password === confirmPassword && password.length !== 0 ? <GridCheckCircleIcon  color='primary'  /> : <CancelIcon/>} Password match
            </div>
        </div>
    )
}